import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Loader from 'components/layout/Loader';
// import Spinner from 'components/Spinner';
import { intlModule } from '@chedri/base';
import DatePicker from 'components/forms/DatePicker';
import { Button, Col, Row } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import ListFilterClient from 'components/layout/list/filters/ListFilterClient';
import ListFilterCompany from 'components/layout/list/filters/ListFilterCompany';
import TableResponsive from 'components/layout/TableResponsive';
import ListFilterWhiteLabel from 'components/layout/list/filters/ListFilterWhiteLabel';

const CustomizedAxisTick = ({ x, y, stroke, payload }) => (
  <g transform={`translate(${x},${y})`}>
    <text x={0} y={-10} dy={16} textAnchor="end" fill="#666" transform="rotate(-90)">
      {payload.value}
    </text>
  </g>
);

const CouponStats = () => {
  const messages = useSelector(intlModule.selectors.getMessages);
  const { widget_order_stats: messagesWos, widget_item_stats: messagesWis } = messages;
  const {
    used_coupons_title: title,
    total_used_coupons_count_label_title: totalUsedCouponsCountLabelTitle,
    total_used_coupons_value_label_title: totalUsedCouponsValueLabelTitle,
  } = messagesWis;
  const [countUsedCoupons, setCountUsedCoupons] = useState(0);
  const [sumUsedCoupons, setSumUsedCoupons] = useState(0.0);
  const [usedCouponsDailyStats, setUsedCouponsDailyStats] = useState([]);
  const [dateA, setDateA] = useState(moment().startOf('month'));
  const [dateB, setDateB] = useState(new Date());
  const [loadedStartDate, setLoadedStartDate] = useState(null);
  const [loadedEndDate, setLoadedEndDate] = useState(null);
  const [filterWhiteLabels, setFilterWhiteLabels] = useState([]);
  const [filterCompanies, setFilterCompanies] = useState([]);
  const [filterClients, setFilterClients] = useState([]);
  const [abortController, setAbortController] = useState(null);
  const appIntl = useSelector(({ intl }) => intl);
  const user = useSelector(({ login: { user } }) => user);
  const timezone =
    Intl?.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone ?? user?.profile?.timezone ?? 'Europe/Berlin';

  const [dateFrom, dateTo] = dateA < dateB ? [dateA, dateB] : [dateB, dateA];

  const listFilterWhiteLabelsRef = useRef();
  const listFilterCompaniesRef = useRef();
  const listFilterClientsRef = useRef();
  const listFilterItemsRef = useRef();

  const saveWhiteLabelRef = ref => {
    console.log('saveWhiteLabelRef');
    listFilterWhiteLabelsRef.current = ref;
  };
  const saveCompanyRef = ref => {
    console.log('saveCompanyRef');
    listFilterCompaniesRef.current = ref;
  };
  const saveClientRef = ref => {
    console.log('saveClientRef');
    listFilterClientsRef.current = ref;
  };

  const saveItemRef = ref => {
    console.log('saveItemRef');
    listFilterItemsRef.current = ref;
  };

  const colorCount = '#8884d8';
  const colorValue = '#82ca9d';

  const whiteLabelsUpdated = whiteLabelsDict => {
    const ids = Object.keys(whiteLabelsDict).sort();
    setFilterWhiteLabels(ids);
    console.log('companiesUpdated', { current: listFilterWhiteLabelsRef?.current });
  };
  const companiesUpdated = companiesDict => {
    const names = Object.keys(companiesDict).sort();
    setFilterCompanies(names);
    setFilterClients([]);
    // eslint-disable-next-line no-unused-expressions
    listFilterClientsRef?.current?.deselectAll?.(true);
    console.log('companiesUpdated', { current: listFilterClientsRef?.current });
  };

  const clientsUpdated = clientsDict => {
    const names = Object.keys(clientsDict).sort();
    setFilterCompanies([]);
    setFilterClients(names);
    // eslint-disable-next-line no-unused-expressions
    listFilterCompaniesRef?.current?.deselectAll?.(true);
    console.log('clientsUpdated', { current: listFilterCompaniesRef?.current });
  };

  useEffect(() => {
    const start = moment(dateFrom)
      .startOf('day')
      .format();
    const end = moment(dateTo)
      .endOf('day')
      .format();

    if (abortController) {
      // cancel previous request that is still running
      abortController.abort();
    }
    const controller = new AbortController();
    const { signal } = controller;
    setAbortController(controller);

    const params = { start, end };
    if (filterCompanies.length > 0) {
      params.companies = filterCompanies;
    } else if (filterClients.length > 0) {
      params.clients = filterClients;
    }

    if (filterWhiteLabels.length > 0) {
      params.whiteLabels = filterWhiteLabels;
    }

    axios
      .get('/api/usedcouponstats.json', { params, signal })
      .then(({ data }) => {
        const { count, value, item_date_stats: itemDateStats, start_date: startDate, end_date: endDate } = data;
        setCountUsedCoupons(count);
        setSumUsedCoupons(value);
        setUsedCouponsDailyStats(itemDateStats);
        setLoadedStartDate(new Date(startDate));
        setLoadedEndDate(new Date(endDate));
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setAbortController(null);
      });
  }, [dateFrom, dateTo, filterWhiteLabels, filterCompanies, filterClients]);

  const dateFormatter = new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  const isDatesLoaded = loadedStartDate && loadedEndDate;
  let subtitle = isDatesLoaded
    ? `${dateFormatter.format(loadedStartDate)} — ${dateFormatter.format(loadedEndDate)}`
    : messagesWos.loading;
  if (filterCompanies.length > 0) {
    subtitle += ` ${messagesWos.for_companies}: ${filterCompanies.join(', ')}`;
  } else if (filterClients.length > 0) {
    subtitle += ` ${messagesWos.for_clients}: ${filterClients.join(', ')}`;
  }

  const dateUpdate = (name, moment) => {
    console.log('dateUpdate', { name, moment, date: moment.toDate() });
    if (name === 'dateFrom') {
      setDateA(moment);
    } else if (name === 'dateTo') {
      setDateB(moment);
    } else {
      console.error('ItemStats.js dateUpdate() Unknown name', { name });
    }
  };

  const quickButtons = () => {
    const lastNMonths = n => ({
      label: messagesWos[`last_${n}_months`],
      range: [
        moment()
          .startOf('month')
          .subtract(n, 'months'),
        moment(),
      ],
    });

    const times = [
      { label: messagesWos.this_month, range: [moment().startOf('month'), moment().endOf('day')] },
      {
        label: messagesWos.previous_month,
        range: [
          moment()
            .startOf('month')
            .subtract(1, 'months'),
          moment().startOf('month'),
        ],
      },
      lastNMonths(3),
      lastNMonths(6),
      lastNMonths(12),
    ];

    const setSelectedRange = ([dateA, dateB]) => () => {
      setDateA(dateA);
      setDateB(dateB);
    };

    return times.map(({ label, range }, i) => (
      <Fragment key={label}>
        <Button
          bsSize="small"
          bsStyle="info"
          onClick={setSelectedRange(range)}
          style={{ marginRight: i < times.length - 1 ? '5px' : '', marginBottom: '5px' }}
        >
          <i className="fas fa-calendar" /> {label}
        </Button>
      </Fragment>
    ));
  };

  const bigFigure = (title, value, color) => (
    <div style={{ textAlign: 'center', height: '100px', paddingTop: '25px', border: '1px solid #CCC' }}>
      <h4>
        {title}: <span style={{ color, fontSize: '1.6rem' }}>{value}</span>
      </h4>
    </div>
  );

  const getRowData = data => {
    return {
      item: data.item,
      turnover: `€${typeof data.count === 'number' ? data.count.toFixed(2) : data.count}`,
      date: moment
        .tz(data.date, 'UTC')
        .tz(timezone)
        .format('DD.MM.YYYY'),
    };
  };

  return (
    <>
      <div className="widget-11-2 card no-border card-condensed widget-loader-circle full-height d-flex flex-column">
        <div className="padding-25">
          <h2 className="no-margin">
            {title}
            {abortController && (
              <>
                {' '}
                <i className="fad fa-spinner-third fa-spin" />
              </>
            )}
          </h2>
          <p className="no-margin">{subtitle}</p>
        </div>
        <div className="padding-25">
          <Row style={{ marginBottom: '25px' }}>
            {loadedStartDate && loadedEndDate ? (
              <>
                <Col xs={12} md={6}>
                  {bigFigure(totalUsedCouponsCountLabelTitle, countUsedCoupons, colorCount)}
                </Col>
                <Col xs={12} md={6}>
                  {bigFigure(
                    totalUsedCouponsValueLabelTitle,
                    `€${typeof sumUsedCoupons === 'number' ? sumUsedCoupons.toFixed(2) : sumUsedCoupons}`,
                    colorValue
                  )}
                </Col>
              </>
            ) : (
              <Col xs={12}>
                <Loader />
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={6} sm={3}>
              <DatePicker
                name="dateFrom"
                value={dateFrom}
                displayTz={timezone}
                returnTz={timezone}
                locale={appIntl.locale}
                onChange={dateUpdate}
                label={messages.date_from}
              />
            </Col>
            <Col xs={6} sm={3}>
              <DatePicker
                name="dateTo"
                value={dateTo}
                displayTz={timezone}
                returnTz={timezone}
                locale={appIntl.locale}
                onChange={dateUpdate}
                label={messages.date_to}
              />
            </Col>
            <Col xs={12} sm={6}>
              {quickButtons()}
            </Col>
            {user.username === 'CreacheckAdmin' && (
              <Col xs={12} sm={2}>
                <ListFilterWhiteLabel
                  updateLocation={false}
                  onUpdate={whiteLabelsUpdated}
                  listName="myWhiteLabelProject"
                  saveRef={saveWhiteLabelRef}
                />
              </Col>
            )}
            <Col xs={12} sm={2}>
              <ListFilterCompany updateLocation={false} onUpdate={companiesUpdated} saveRef={saveCompanyRef} />
            </Col>
            <Col xs={12} sm={2}>
              <ListFilterClient
                updateLocation={false}
                onUpdate={clientsUpdated}
                listName="clientUsers"
                saveRef={saveClientRef}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <div
                style={{
                  border: '1px solid rgb(204, 204, 204)',
                  maxHeight: '407px',
                  overflow: 'auto',
                  paddingLeft: '25px',
                  paddingRight: '25px',
                }}
              >
                {usedCouponsDailyStats.length ? (
                  <TableResponsive
                    headers={{ item: messages.coupon, count: messages.turnover, date: messages.date }}
                    rows={usedCouponsDailyStats.map(dateItem => getRowData(dateItem))}
                    hover
                    style={{ maxHeight: '400px', overflow: 'scroll' }}
                  />
                ) : (
                  <div class="p-r-25 p-t-25 p-b-25">
                    <i class="fas fa-info m-r-10" /> {messages.no_data}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default CouponStats;
